import { render } from "./SpreadsheetItem.vue?vue&type=template&id=1712344e&scoped=true&ts=true"
import script from "./SpreadsheetItem.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetItem.vue?vue&type=script&lang=ts"

import "./SpreadsheetItem.vue?vue&type=style&index=0&id=1712344e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1712344e"]])

export default __exports__